import { render, staticRenderFns } from "./Caichan.vue?vue&type=template&id=4e149d28&scoped=true&"
import script from "./Caichan.vue?vue&type=script&lang=js&"
export * from "./Caichan.vue?vue&type=script&lang=js&"
import style0 from "./Caichan.vue?vue&type=style&index=0&id=4e149d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e149d28",
  null
  
)

export default component.exports